module.exports = __webpack_public_path__ + "img/sail-croatia-stamp.a3991f4a.jpg";